import request from '@/util/request';
// import qs from 'qs';

// // 字典数据
// export const getDict = (params, options) =>
//     request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));
//新增盘点任务
export const createTemporaryTask = (params, options) =>
    request.post('/api/v4ward/warehouse/check/createTemporaryTask', params, options);
//盘点任务列表
export const checkPage = (params, options) =>
    request.get('/api/v4ward/warehouse/check/page', Object.assign({}, options, { params }));
//盘点任务详情
export const checkDetail = (params, options) =>
    request.get('/api/v4ward/warehouse/check/detail', Object.assign({}, options, { params }));
//盘点任务商品列表
export const checkConsumablePage = (params, options) =>
    request.get('/api/v4ward/warehouse/check/consumable/page', Object.assign({}, options, { params }));
//盘点任务保存
export const save = (params, options) =>
    request.post('/api/v4ward/warehouse/check/consumable/save', params, options);
//盘点任务提交
export const submit = (params, options) =>
    request.post('/api/v4ward/warehouse/check/consumable/submit', params, options);
//完成后的详情
export const losePage = (params, options) =>
    request.get('/api/v4ward/warehouse/check/consumable/losePage', Object.assign({}, options, { params }));
export const profitPage = (params, options) =>
    request.get('/api/v4ward/warehouse/check/consumable/profitPage', Object.assign({}, options, { params }));
//更新库存
export const updateStock = (params, options) =>
    request.get('/api/v4ward/warehouse/check/consumable/updateStockByCheckId', Object.assign({}, options, { params }));
//盈亏汇总
export const profitLoseSum = (params, options) =>
    request.get('/api/v4ward/warehouse/check/consumable/profitLoseSum', Object.assign({}, options, { params }));